import axios from "axios";

export const getEducationInstitutions = callback => {
  var promise = axios({
    method: "get",
    url: "/api/education_institutions"
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};
